import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const catholicHouseholdSchema = new schema.Entity(
  'catholic_households',
  {},
  {
    idAttribute: 'id',
  }
)

export const catholicHouseholdMemberSchema = new schema.Entity(
  'catholic_household_members',
  {},
  {
    idAttribute: 'id',
  }
)

// Route::get('catholic-households/catholic-household/{id}/get', 'CatholicHouseholdController@getById');
export const catholicHousehold_getById_Api = {
  backend: `Route::get('catholic-households/catholic-household/{id}/get', 'CatholicHouseholdController@getById');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household/:id/get',
  method: 'GET',
  schema: catholicHouseholdSchema,
  transform: createTransform(catholicHouseholdSchema, 'data'),
}
// Route::get('catholic-households/{type}/{id}/gets', 'CatholicHouseholdController@getCatholicHouseholds');
export const catholicHousehold_getCatholicHouseholds_Api = {
  backend: `Route::get('catholic-households/{type}/{id}/gets', 'CatholicHouseholdController@getCatholicHouseholds');`,
  root: API_ROOT_URL,
  path: '/catholic-households/:type/:id/gets',
  method: 'GET',
  paramsFields: ['sort_by', 'status', 'keyword'],
  schema: catholicHouseholdSchema,
  transform: createListTransform(catholicHouseholdSchema),
}
// Route::get('catholic-households/{type}/{id}/get-stats', 'CatholicHouseholdController@getCatholicHouseholdStats');
export const catholicHousehold_getCatholicHouseholdStats_Api = {
  backend: `Route::get('catholic-households/{type}/{id}/get-stats', 'CatholicHouseholdController@getCatholicHouseholdStats');`,
  root: API_ROOT_URL,
  path: '/catholic-households/:type/:id/get-stats',
  method: 'GET',
}
// Route::get('catholic-households/get-mines', 'CatholicHouseholdController@getMyCatholicHouseholds');
export const catholicHousehold_getMyCatholicHouseholds_Api = {
  backend: `Route::get('catholic-households/get-mines', 'CatholicHouseholdController@getMyCatholicHouseholds');`,
  root: API_ROOT_URL,
  path: '/catholic-households/get-mines',
  method: 'GET',
  paramsFields: ['sort_by', 'active', 'keyword', 'organization_id'],
  schema: catholicHouseholdSchema,
  transform: createListTransform(catholicHouseholdSchema),
}
// Route::get('catholic-households/catholic-household/{id}/members/gets', 'CatholicHouseholdMemberController@getCatholicHouseholdMembers');
export const catholicHousehold_getCatholicHouseholdMembers_Api = {
  backend: `Route::get('catholic-households/catholic-household/{id}/members/gets', 'CatholicHouseholdMemberController@getCatholicHouseholdMembers');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household/:id/members/gets',
  method: 'GET',
  paramsFields: ['sort_by', 'active', 'keyword'],
  schema: catholicHouseholdMemberSchema,
  transform: createListTransform(catholicHouseholdMemberSchema),
}
// Route::get('catholic-households/{type}/{id}/members/query', 'CatholicHouseholdMemberController@fetchCatholicHouseholdMembers');
export const catholicHousehold_fetchCatholicHouseholdMembers_Api = {
  backend: `Route::get('catholic-households/{type}/{id}/members/query', 'CatholicHouseholdMemberController@fetchCatholicHouseholdMembers');`,
  root: API_ROOT_URL,
  path: '/catholic-households/:type/:id/members/query',
  method: 'GET',
  paramsFields: ['sort_by', 'sacrament_type', 'keyword'],
  schema: catholicHouseholdMemberSchema,
  transform: createListTransform(catholicHouseholdMemberSchema),
}

// Route::post('catholic-households/catholic-household/create-new', 'CatholicHouseholdController@createMyHouseholdBook');
export const catholicHousehold_createMyHouseholdBook_Api = {
  backend: `Route::post('catholic-households/catholic-household/create-new', 'CatholicHouseholdController@createMyHouseholdBook');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household/create-new',
  method: 'POST',
  paramsFields: [],
  schema: catholicHouseholdSchema,
  transform: createTransform(catholicHouseholdSchema, 'data'),
}
// Route::post('catholic-households/{owner_type}/{owner_id}/catholic-household/create-new', 'CatholicHouseholdController@createHousehold');
export const catholicHousehold_createHousehold_Api = {
  backend: `Route::post('catholic-households/{owner_type}/{owner_id}/catholic-household/create-new', 'CatholicHouseholdController@createHousehold');`,
  root: API_ROOT_URL,
  path: '/catholic-households/:type/:id/catholic-household/create-new',
  method: 'POST',
  paramsFields: [],
  schema: catholicHouseholdSchema,
  transform: createTransform(catholicHouseholdSchema, 'data'),
}
// Route::post('catholic-households/catholic-household/{id}/update', 'CatholicHouseholdController@updateHousehold');
export const catholicHousehold_updateHousehold_Api = {
  backend: `Route::post('catholic-households/catholic-household/{id}/update', 'CatholicHouseholdController@updateHousehold');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household/:id/update',
  method: 'POST',
  paramsFields: [],
  schema: catholicHouseholdSchema,
  transform: createTransform(catholicHouseholdSchema, 'data'),
}
// Route::post('catholic-households/catholic-household/{id}/change-status', 'CatholicHouseholdController@changeHouseholdStatus');
export const catholicHousehold_changeHouseholdStatus_Api = {
  backend: `Route::post('catholic-households/catholic-household/{id}/change-status', 'CatholicHouseholdController@changeHouseholdStatus');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household/:id/change-status',
  method: 'POST',
  paramsFields: [],
  schema: catholicHouseholdSchema,
  transform: createTransform(catholicHouseholdSchema, 'data'),
}
// Route::post('catholic-households/catholic-household/{id}/delete', 'CatholicHouseholdController@deleteHousehold');
export const catholicHousehold_deleteHousehold_Api = {
  backend: `Route::post('catholic-households/catholic-household/{id}/delete', 'CatholicHouseholdController@deleteHousehold');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household/:id/delete',
  method: 'POST',
  paramsFields: [],
  schema: catholicHouseholdSchema,
  transform: createTransform(catholicHouseholdSchema, 'data'),
}


// Route::get('catholic-households/catholic-household-member/{id}/get', 'CatholicHouseholdMemberController@getById');
export const catholicHouseholdMember_getById_Api = {
  backend: `Route::get('catholic-households/catholic-household-member/{id}/get', 'CatholicHouseholdMemberController@getById');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household-member/:id/get',
  method: 'GET',
  schema: catholicHouseholdMemberSchema,
  transform: createTransform(catholicHouseholdMemberSchema, 'data'),
}


// Route::post('catholic-households/catholic-household/{id}/members/create-new', 'CatholicHouseholdMemberController@createHouseholdMember');
export const catholicHousehold_createHouseholdMember_Api = {
  backend: `Route::post('catholic-households/catholic-household/{id}/members/create-new', 'CatholicHouseholdMemberController@createHouseholdMember');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household/:id/members/create-new',
  method: 'POST',
  paramsFields: [],
  schema: catholicHouseholdSchema,
  transform: createTransform(catholicHouseholdSchema, 'data'),
}
// Route::post('catholic-households/catholic-household-members/{id}/update', 'CatholicHouseholdMemberController@updateHouseholdMember');
export const catholicHousehold_updateHouseholdMember_Api = {
  backend: `Route::post('catholic-households/catholic-household-members/{id}/update', 'CatholicHouseholdMemberController@updateHouseholdMember');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household-members/:id/update',
  method: 'POST',
  paramsFields: [],
  schema: catholicHouseholdSchema,
  transform: createTransform(catholicHouseholdSchema, 'data'),
}
// Route::post('catholic-households/catholic-household-members/{id}/delete', 'CatholicHouseholdMemberController@deleteHouseholdMember');
export const catholicHousehold_deleteHouseholdMember_Api = {
  backend: `Route::post('catholic-households/catholic-household-members/{id}/delete', 'CatholicHouseholdMemberController@deleteHouseholdMember');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household-members/:id/delete',
  method: 'POST',
  paramsFields: [],
  schema: catholicHouseholdSchema,
  transform: createTransform(catholicHouseholdSchema, 'data'),
}


// Route::get('catholic-households/catholic-household/{id}/get-logs', 'CatholicHouseholdController@fetchChangeLogs');
export const catholicHousehold_fetchChangeLogs_Api = {
  backend: `Route::get('catholic-households/catholic-household/{id}/get-logs', 'CatholicHouseholdController@fetchChangeLogs');`,
  root: API_ROOT_URL,
  path: '/catholic-households/catholic-household/:id/get-logs',
  method: 'GET',
}

export const catholicHousehold_doImportFile_Api = {
  name: 'catholicHousehold_doImportFile_Api',
  backend: `Route::post('catholic-households/{owner_type}/{owner_id}/catholic-household/do-import-file', 'CatholicHouseholdController@importCatholicHouseholdFile');`,
  root: API_ROOT_URL,
  path: '/catholic-households/:type/:id/catholic-household/do-import-file',
  method: 'POST',
}